import React, { FC, PropsWithChildren } from 'react';
import { Button as NativeButton } from '@tarojs/components';
import { ButtonProps } from '@tarojs/components/types/Button';

const Button: FC<PropsWithChildren<ButtonProps>> = ({ children, className, ...restProps }) => (
  <NativeButton className={`ace-button ${className}`} {...restProps}>
    {children}
  </NativeButton>
);

export default Button;
